import React, { useCallback } from 'react'
import { TablePagination as MuiTablePagination } from '@mui/material'

interface TablePaginationProps {
  total: number
  page: number
  rowsPerPage: number
  rowsPerPageOptions?: Array<number | { value: number; label: string }>
  onPageChange: (page: number) => void
  onRowsPerPageChange?: (perPage: number) => void
}

export function TablePagination(props: TablePaginationProps) {
  const {
    total,
    page,
    rowsPerPage,
    rowsPerPageOptions = [10, 25, 50, 100],
    onPageChange,
    onRowsPerPageChange,
  } = props

  const pageChange = useCallback(
    (_: unknown, page: number) => {
      onPageChange(page)
    },
    [onPageChange],
  )
  const perPageChange: React.ChangeEventHandler<
    HTMLTextAreaElement | HTMLInputElement
  > = useCallback(
    (e) => {
      onRowsPerPageChange?.(Number(e.target.value))
    },
    [onRowsPerPageChange],
  )

  if (total <= 500) {
    rowsPerPageOptions.push({ value: -1, label: 'All' })
  }
  return (
    <MuiTablePagination
      count={total}
      page={page}
      rowsPerPageOptions={rowsPerPageOptions}
      rowsPerPage={rowsPerPage}
      onPageChange={pageChange}
      onRowsPerPageChange={perPageChange}
      component="div"
      sx={{
        '.MuiTablePagination-toolbar': {
          backgroundColor: 'white',
          color: 'black',
          height: '35px',
          borderTop: 'solid 1px lightGrey',
        },
      }}
    />
  )
}
